import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'
import { paramsSelector, useStore } from '@liveHelper/models/store'
import { isOnline } from '@oneToOne/shared/utils/widgetAvailability'

/**
 * Hook to determine if current widget is offline. If neither the config nor the
 * widget availability is specified, it defaults to online (false).
 * @todo Refactor to useIsOnline hook to avoid double negatives.
 */
export const useIsOffline = () => {
  const chatChannelConfig = useChatChannelConfig()
  const params = useStore(paramsSelector)

  if (chatChannelConfig) {
    if (!chatChannelConfig.config?.widget_availability) {
      return false
    }

    if (
      params.bypass_widget_availability_hidden &&
      chatChannelConfig.config.widget_availability === 'never'
    ) {
      return !chatChannelConfig.config.agent_available
    }

    return !isOnline(chatChannelConfig)
  }

  return false
}
